<template>
  <div id="bd-thread-right">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <!-- TODO: 用户信息放在快捷回复上方，同时可见，不需要切换tab -->
      <el-tab-pane :label="userInfoTip" name="info">
        <bd-info></bd-info>
      </el-tab-pane>
      <el-tab-pane :label="cuwTip" name="cuw">
        <bd-cuw></bd-cuw>
      </el-tab-pane>
      <el-tab-pane :label="deviceTip" name="device">
        <bd-device></bd-device>
      </el-tab-pane>
      <!-- <el-tab-pane v-if="showAuthority.debug" label="知识库" name="support">
        <bd-support></bd-support>
      </el-tab-pane> -->
      <!-- <el-tab-pane label="历史会话" name="thread">
        <bd-thread></bd-thread>
      </el-tab-pane> -->
      <!-- <el-tab-pane v-if="showAuthority.debug" label="音视频" name="rtc">
        <bd-rtc></bd-rtc>
      </el-tab-pane> -->
    </el-tabs>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import BdCuw from "@/components/dashboard/main/monitor/children/right/BdCuw";
import BdInfo from "@/components/dashboard/main/monitor/children/right/BdInfo";
import BdDevice from "@/components/dashboard/main/monitor/children/right/BdDevice";
// import BdSupport from '@/components/dashboard/main/monitor/children/right/BdSupport'
// import BdThread from '@/components/dashboard/main/monitor/children/right/BdThread'
// import BdRtc from '@/components/dashboard/main/monitor/children/right/BdRTC'
import bus from "@/util/eventbus";
const constants = require("@/util/constants");

export default {
  name: "bd-thread-right",
  // BdSupport, BdThread, BdRtc
  components: { BdCuw, BdInfo, BdDevice },
  data() {
    return {
      activeName: "info",
      showRTCTab: true, // 为方便测试设置为true
    };
  },
  computed: {
    ...mapGetters(["userCurrentMonitorThread", "showAuthority"]),
    username() {
      return this.userCurrentMonitorThread.visitor.username;
    },
    userInfoTip() {
      return this.$t("userInfo");
    },
    cuwTip() {
      return this.$t("cuw");
    },
    historyThreadTip() {
      return this.$t("historyThread");
    },
    ticketTip() {
      return this.$t("tickets");
    },
    deviceTip() {
      return this.$t("deviceInfo");
    },
    knowledgeTip() {
      return this.$t("knowledge");
    },
    webrtcTip() {
      return this.$t("webrtc");
    },
  },
  methods: {
    ...mapActions(["getCuws", "fingerPrint", "userTag"]),
    handleClick(tab, event) {
      if (tab.name === "cuw") {
        // this.getCuws()
      } else if (tab.name === "info") {
        //
      }
    },
  },
  mounted() {
    this.getCuws();
    // 本地消息通知
    bus.$on(constants.EVENT_BUS_WEBRTC_ACCEPT, (message) => {
      console.log("right eventbus: ", message);
      this.showRTCTab = true;
    });
  },
};
</script>

<style scoped>
#bd-thread-right {
  width: 100%;
  height: 100%;
}
.el-tabs {
  height: 100%;
  margin-left: 8px;
}
.el-tab-pane {
  padding: 0px 10px 5px 10px;
  height: calc(100% - 100px) !important;
}
.el-tabs__content {
  height: 100% !important;
  overflow-y: scroll !important;
}
</style>
